import React from 'react'

const AboutBanner = () => (
    <div className='about-banner'>
        <div className='container'>
            <div className="banner-heading">
                <h1>About Us</h1>
                <div className="divider-shape"></div>
            </div>
            
        </div>
    </div>
)

export default AboutBanner